import { useSpeedManagmentCommand } from "./hooks/useSpeedManagmentCommand.js";
import FormSpeedManagment from "./components/FormSpeedManagment.jsx";

function SpeedManagment() {
  const {
    speedManagment,
    handleChange,
    errors: { errors },
    createSpeedManagment,
  } = useSpeedManagmentCommand();

  const handleSubmit = () => {
    createSpeedManagment();
  };

  return (
    <main className="container p-4">
      <header className="d-flex justify-content-between align-items-center mb-4 px-3 py-2 border-bottom">
        <h1 className="h2 m-0 fw-bold">Registrar gestión de velocidad</h1>
      </header>
      <section className="shadow w-100 d-flex flex-column">
        <div className="d-flex gap-3">
          <div className="w-100">
            <p>
              Formulario de registro de gestión de velocidad. Selecciona el mes:
              si ese mes ya tiene datos, se actualizarán en la misma fila (solo
              puede existir un registro por mes).
            </p>
            <FormSpeedManagment
              speedManagment={speedManagment}
              onChange={handleChange}
              errors={errors}
              onSubmit={handleSubmit}
            />
          </div>
        </div>
      </section>
    </main>
  );
}

export default SpeedManagment;
